import axios from 'axios';
import { useQuery, useMutation } from 'react-query';

import config from '../config';
import { useVpSnackbar } from '../vp-ui';

// apis
const fetchCampaignDomainAvailable = ({ queryKey }) =>
  axios.get(`${config?.apiHost}/v1/custom-domain/campaign/${queryKey[1]}/domain/${queryKey[2]}`, {
    withCredentials: true
  });
const updateCampaignDomain = ({ data, campaignId }) =>
  axios.post(`${config?.apiHost}/v1/custom-domain/${campaignId}`, data, { withCredentials: true });

// queries
export const useCampaignDomainAvailableData = (campaignId, domainName, enabled = false) => {
  const { addSnackbarError } = useVpSnackbar();
  return useQuery(
    ['campaignDomainAvailable', campaignId, domainName],
    fetchCampaignDomainAvailable,
    {
      enabled: !!campaignId && !!domainName && enabled,
      staleTime: Infinity,
      retry: false,
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      onError: (e) => {
        addSnackbarError({ title: e?.response?.data?.error, message: e?.response?.data?.message });
      }
    }
  );
};

// mutations
export const useUpdateCampaignDomainData = () => useMutation(updateCampaignDomain);



// WEBPACK FOOTER //
// ./src/hooks/useCampaignDomainData.js